// client/src/pages/Checkout.js

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../api";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

function Checkout() {
  const { id } = useParams(); // examId
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [nameOnCertificate, setNameOnCertificate] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [payableAmount, setPayableAmount] = useState(null);
  const [message, setMessage] = useState(null); // text
  const [messageType, setMessageType] = useState(""); // "success" | "error"

  useEffect(() => {
    const fetchExam = async () => {
      try {
        const res = await api.get(`/api/exams/${id}`);
        setExam(res.data);
        setPayableAmount(res.data.price); // initial amount
      } catch (err) {
        console.error("Failed to fetch exam:", err.response?.data || err.message);
      }
    };

    fetchExam();
  }, [id]);

  const handleApplyCoupon = () => {
    if (!exam) return;

    if (couponCode.trim().toUpperCase() === "INTERNALPASS") {
      const discounted = Math.round(exam.price * 0.1); // pay 10%
      setPayableAmount(discounted);
  setMessage("Coupon applied: 90% off");
  setMessageType("success");
    } else {
      setPayableAmount(exam.price);
  setMessage("Invalid coupon. Price reset.");
  setMessageType("error");
    }
  };

  const startPayment = async () => {
    if (!nameOnCertificate.trim()) {
      setMessage("Please enter your full name for the certificate.");
      setMessageType("error");
      return;
    }

    const ok = await loadRazorpayScript();
    if (!ok) {
      alert("Razorpay SDK failed to load");
      return;
    }

    try {
      // 1. Create order on backend
      const orderRes = await api.post("/api/payments/create-order", {
        examId: id,
        nameOnCertificate,
        couponCode,
      });

      const { orderId, amount, razorpayKeyId } = orderRes.data;
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      // 2. Open Razorpay checkout
      const options = {
        key: razorpayKeyId,
        amount: amount * 100,
        currency: "INR",
        name: exam.title,
        description: "Orivon Academy Certification",
        order_id: orderId,
        prefill: {
          name: user.name,
          email: user.email,
        },
        handler: async function (response) {
          // 3. Verify payment with backend
            try {
              await api.post("/api/payments/verify", {
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpaySignature: response.razorpay_signature,
              });

              setMessage("Payment successful! Certification unlocked.");
              setMessageType("success");

              // Replace history entry so Back doesn't go to Checkout again
              navigate("/dashboard?tab=my", { replace: true });
            } catch (err) {
              console.error("Verify payment error:", err.response?.data || err.message);
              setMessage("Payment verification failed");
              setMessageType("error");
            }
        },
        theme: {
          color: "#0f766e",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Create order error:", err.response?.data || err.message);
      const errorMsg = err.response?.data?.message || err.message || "Could not start payment";
      setMessage(`Payment Error: ${errorMsg}`);
      setMessageType("error");
    }
  };

  if (!exam) return <div>Loading...</div>;

  return (
    <div style={{ padding: 40 }}>
      {message && (
        <div
          style={{
            marginTop: 16,
            marginBottom: 16,
            padding: 10,
            borderRadius: 4,
            backgroundColor: messageType === "error" ? "#fee2e2" : "#dcfce7",
            color: messageType === "error" ? "#991b1b" : "#166534",
            border: "1px solid",
            borderColor: messageType === "error" ? "#fecaca" : "#bbf7d0",
            fontSize: 14,
          }}
        >
          {message}
        </div>
      )}
      <h1>Checkout – {exam.title}</h1>

      <p>{exam.description}</p>
      <p>
        <strong>Amount:</strong> ₹{payableAmount ?? exam.price}
      </p>

      <div style={{ marginTop: 20 }}>
        <label>
          Name on Certificate:
          <br />
          <input
            type="text"
            value={nameOnCertificate}
            onChange={(e) => setNameOnCertificate(e.target.value)}
            style={{ width: 300, padding: 8, marginTop: 8 }}
            placeholder="Your full name"
          />
        </label>
      </div>

      <div style={{ marginTop: 20 }}>
        <label>
          Coupon Code:
          <br />
          <input
            type="text"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            style={{ width: 200, padding: 8, marginTop: 8, marginRight: 8 }}
            placeholder='e.g. INTERNALPASS'
          />
        </label>
        <button
          type="button"
          onClick={handleApplyCoupon}
          style={{ padding: "8px 16px", cursor: "pointer" }}
        >
          Apply
        </button>
      </div>

      <button
        onClick={startPayment}
        style={{
          marginTop: 24,
          padding: "12px 24px",
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        Pay & Start Certification
      </button>
    </div>
  );
}

export default Checkout;

